
const firebaseConfig = {
  apiKey: "AIzaSyCF0qVIgcR0i6jNNhYFQQTnHCl99WdaLW4",
  authDomain: "todo-list-ae666.firebaseapp.com",
  projectId: "todo-list-ae666",
  storageBucket: "todo-list-ae666.firebasestorage.app",
  messagingSenderId: "540516612823",
  appId: "1:540516612823:web:620b9dc15f4a8c2ba80e92",
  measurementId: "G-FNY3NX8QNR"
};

export default firebaseConfig; 